import { Clock, Sparkles } from "lucide-react";
import { useSiteFlags } from "@/context/SiteFlagsContext";

// Bloque «Próximamente disponible»: título, texto y lista editables en Admin → IA & Cerebro → «Servicios visibles».
export const ProximamenteSection = () => {
  const { proximamente: p } = useSiteFlags();
  if (!p?.visible) return null;
  return (
    <section id="proximamente" className="max-w-7xl mx-auto px-5 md:px-8 py-14 md:py-20 scroll-mt-20" data-testid="proximamente-section">
      <div className="rounded-3xl border border-[#F5B301]/40 bg-[#13315C] text-white p-8 md:p-12 grid md:grid-cols-[1.1fr_1fr] gap-8 items-center">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-[#F5B301]/15 border border-[#F5B301]/40 px-3 py-1.5 text-xs font-bold text-[#F5B301] uppercase tracking-wider" data-testid="proximamente-badge">
            <Clock size={14} /> {p.titulo}
          </span>
          <p className="mt-5 font-display font-bold text-2xl md:text-3xl leading-tight" data-testid="proximamente-texto">{p.texto}</p>
        </div>
        {p.servicios?.length > 0 && (
          <ul className="space-y-2.5" data-testid="proximamente-servicios">
            {p.servicios.map((s, i) => (
              <li key={s} className="flex items-center gap-3 rounded-xl bg-white/5 border border-white/10 px-4 py-3 text-sm font-semibold" data-testid={`proximamente-servicio-${i}`}>
                <Sparkles size={15} className="text-[#F5B301] shrink-0" /> {s}
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
};
